import React from 'react';
import styled from 'styled-components';
import { colors, spaces, typography } from '@99designs/ui/settings';

export interface DividerWithTextProps {
    text: string;
}

const Divider = styled.div`
    display: flex;
    align-items: center;
    text-align: center;
    font-size: ${typography.fontSizes.paragraphs.small}px;
    color: ${colors.puntRoad};

    &::before,
    &::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid ${colors.t1000};
    }
    &::before {
        margin-right: ${spaces.halfGutter};
    }
    &::after {
        margin-left: ${spaces.halfGutter};
    }
`;

export function DividerWithText({ text }: DividerWithTextProps) {
    return <Divider role="separator">{text}</Divider>;
}
